import { useRef, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

const Portal = ({
  children,
  selector
}) => {
  const ref = useRef();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    ref.current = document.querySelector(selector);
    setMounted(true);
  }, [selector]);
  return mounted ? /*#__PURE__*/createPortal(children, ref.current) : null;
};

export { Portal as default };
//# sourceMappingURL=Portal.js.map
